/** Formats a string for a CSV column */
export default function formatForCSV(string: string | null) {
	if (!string) {
		return '""';
	}
	
	return `"${string
		.replace(/[“”‘’]/g, (match) => {
			if (match === '“' || match === '”') {
				return '"';
			}
			
			return "'";
		})
		.replace(/"/g, '""')
		.trim()}"`;
}
